/**
 * Deep-link / legacy route: account deletion only (sheet modal).
 * Policies live in the global menu (legal document modals).
 */

import { useState } from 'react'
import { View } from 'react-native'
import { useRouter } from 'expo-router'
import { useTheme } from '../../src/theme/useTheme'
import { PrivacyAccountDeletionModal } from '../../components/layout/PrivacyAccountDeletionModal/PrivacyAccountDeletionModal'

export default function PrivacyAndDataScreen() {
  const router = useRouter()
  const theme = useTheme()
  const [sheetOpen, setSheetOpen] = useState(true)

  return (
    <View style={{ flex: 1, backgroundColor: theme.background.primary }}>
      <PrivacyAccountDeletionModal
        isVisible={sheetOpen}
        onDismiss={() => {
          setSheetOpen(false)
          if (router.canGoBack()) {
            router.back()
          } else {
            router.replace('/app/')
          }
        }}
        testID="privacy-and-data-route-deletion-modal"
      />
    </View>
  )
}
